import type {
  TreatmentPlanV3MutationFlag,
  TreatmentPlanV3RequestAction,
  TreatmentPlanV3State,
} from './types';

export function startTreatmentPlanV3Mutation(
  state: TreatmentPlanV3State,
  flag: TreatmentPlanV3MutationFlag,
  action: TreatmentPlanV3RequestAction,
) {
  state[flag] = true;
  const ids = state.mutationRequestIds[flag];
  if (ids) {
    ids.push(action.meta.requestId);
  } else {
    state.mutationRequestIds[flag] = [action.meta.requestId];
  }
  state.error = null;
}

// Returns false when the response is not an in-flight request for this flag.
export function finishTreatmentPlanV3Mutation(
  state: TreatmentPlanV3State,
  flag: TreatmentPlanV3MutationFlag,
  action: TreatmentPlanV3RequestAction,
) {
  const ids = state.mutationRequestIds[flag];
  if (!ids) return false;
  const index = ids.indexOf(action.meta.requestId);
  if (index === -1) return false;
  ids.splice(index, 1);
  if (ids.length === 0) {
    state[flag] = false;
    delete state.mutationRequestIds[flag];
  }
  return true;
}

// Schedule checks read this flag from the child page; the education page is what the user edits.
export function applyLoadedEducationNotAttendingSchool(
  state: TreatmentPlanV3State,
  treatmentPlanId: string,
) {
  if (
    state.childPage == null ||
    state.childPageTreatmentPlanId !== treatmentPlanId ||
    state.educationPage == null ||
    state.educationPageTreatmentPlanId !== treatmentPlanId
  ) {
    return;
  }
  state.childPage.not_attending_school = state.educationPage.not_attending_school;
}
